import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isEditionOneOf } from './is-edition-one-of';

/**
 * Eligibility for Confluence Premium Popup (Confluence in trial or predunning).
 */
export function isEligibleForConfluencePremiumPopup(context: EditionAwarenessContextType): boolean {
	const { product, edition, isInTrial, isInPredunning, isInCollection } = context;

	return Boolean(
		isInCollection === 'NOT_IN_COLLECTION' &&
		isEditionOneOf(edition, ['premium']) &&
		product === 'confluence' &&
		(isInTrial || isInPredunning),
	);
}
